import {
  IAvailableMarkets,
  IDropDownOption,
  ISelectButtons,
  ISliderValues,
} from '~/sharedInterfaces/SharedInterfaces';
import translations, { ICombinedTranslations } from '~/translations';

interface IValueDefaults {
  defaultValue: number;
  defaultButtons: number[];
  defaultOptions: number[];
}

const defaultContents = {
  defaultValue: 6,
  defaultButtons: [6, 12, 18],
  defaultOptions: Array.from({ length: 18 }, (_, i) => i + 1),
};

const DefaultValues: IAvailableMarkets<IValueDefaults> = {
  se: {
    ...defaultContents,
  },
  no: {
    ...defaultContents,
  },
  nl: {
    ...defaultContents,
  },
  fi: {
    ...defaultContents,
  },
  dk: {
    ...defaultContents,
  },
  be: {
    ...defaultContents,
  },
};

export const getUnit = (locale: keyof ICombinedTranslations) => {
  return (
    translations[locale].components.loanTerm.unit || translations['en-SE'].components.loanTerm.unit
  );
};

export const getDefaults = (market: keyof IAvailableMarkets<IValueDefaults>) => {
  return DefaultValues[market];
};

export const getDefaultValue = (market: keyof IAvailableMarkets<IValueDefaults>) => {
  return DefaultValues[market].defaultValue;
};

export const getDefaultButtons = (market: keyof IAvailableMarkets<IValueDefaults>) => {
  return DefaultValues[market].defaultButtons;
};

export const getDefaultOptions = (market: keyof IAvailableMarkets<IValueDefaults>) => {
  return DefaultValues[market].defaultOptions;
};

export const dropDownOptions = (
  market: keyof IAvailableMarkets<IValueDefaults>,
  locale: keyof ICombinedTranslations
) => {
  const unit = getUnit(locale);
  const options: IDropDownOption[] = getDefaultOptions(market).map((value) => {
    return {
      label: `${value} ${unit}`,
      value,
    };
  });

  return options;
};

export const createButtons = (
  market: keyof IAvailableMarkets<IValueDefaults>,
  locale: keyof ICombinedTranslations
) => {
  const unit = getUnit(locale);
  const buttons: ISelectButtons[] = getDefaultButtons(market).map(
    (value): ISelectButtons => {
      return {
        value,
        valueType: unit,
      };
    }
  );

  return buttons;
};

export const getSliderValues = (
  inputValues: ISliderValues | undefined,
  locale: keyof ICombinedTranslations
) => {
  const min = inputValues?.min || 1;
  const max = inputValues?.max || 18;
  const step = inputValues?.step || 1;
  const defaultValue = inputValues?.defaultValue || 6;
  const unit = getUnit(locale);
  return { min, max, step, defaultValue, unit };
};
